import { Globe } from "lucide-react";
import { LANGS, useLang } from "@/lib/i18n";

export default function LanguageSelector({ compact = false }) {
  const { lang, setLang } = useLang();
  return (
    <div className={`flex items-center gap-1 ${compact ? "" : "border border-gray-200 rounded-full px-2 py-1 bg-white/70"}`}>
      <Globe size={13} className={compact ? "text-white/80" : "text-gray-400"} />
      <select
        data-testid="language-selector"
        value={lang}
        onChange={(e) => setLang(e.target.value)}
        className={`text-[12px] font-semibold outline-none cursor-pointer bg-transparent ${
          compact ? "text-white [&>option]:text-gray-800" : "text-gray-700"
        }`}
      >
        {LANGS.map((l) => (
          <option key={l.code} value={l.code}>{l.name}</option>
        ))}
      </select>
    </div>
  );
}
